import { type ReactNode } from 'react';
import { usePlan } from '../contexts/PlanContext';
import UpgradeBanner from './UpgradeBanner';

interface FeatureGateProps {
  feature: string;
  children: ReactNode;
  fallback?: ReactNode;
}

const FEATURE_PLAN_MAP: Record<string, string> = {
  blog: 'Pro',
  translations: 'Pro',
  seo_advanced: 'Pro',
  custom_domain: 'Pro',
  manual_backup: 'Pro',
  white_label: 'Business',
  priority_support: 'Business',
};

const FEATURE_LABELS: Record<string, string> = {
  blog: 'Blog',
  translations: 'Vertalingen',
  seo_advanced: 'Geavanceerde SEO',
  custom_domain: 'Eigen domein',
  manual_backup: 'Handmatige backups',
  white_label: 'White label',
  priority_support: 'Prioriteit support',
};

export default function FeatureGate({ feature, children, fallback }: FeatureGateProps) {
  const { isFeatureEnabled } = usePlan();

  if (isFeatureEnabled(feature as any)) {
    return <>{children}</>;
  }

  if (fallback !== undefined) {
    return <>{fallback}</>;
  }

  return (
    <UpgradeBanner
      feature={FEATURE_LABELS[feature] ?? feature}
      requiredPlan={FEATURE_PLAN_MAP[feature] ?? 'Pro'}
    />
  );
}
